module.exports = __webpack_public_path__ + "img/isologo-white.c4dcf49b.png";